import { render, staticRenderFns } from "./PInfoMacchina.vue?vue&type=template&id=94053afa&scoped=true"
import script from "./PInfoMacchina.vue?vue&type=script&lang=js"
export * from "./PInfoMacchina.vue?vue&type=script&lang=js"
import style0 from "./PInfoMacchina.vue?vue&type=style&index=0&id=94053afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94053afa",
  null
  
)

export default component.exports